import { useEffect, useState } from "react";

const useBodyContainer = () => {
  const [container, setContainer] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const newContainer = document.createElement("h1");
    newContainer.className = 'visually-hidden';
    document.body.insertBefore(newContainer, document.body.firstChild);
    setContainer(newContainer);

    return () => {
      document.body.removeChild(newContainer);
    };
  }, []); // 空依赖数组确保只执行一次

  return container;
}

export default useBodyContainer;